const resolveModuleDefault = module => module.default || module

export default resolveModuleDefault
